export const FETCH_TMS_TRANSLATIONS = 'FETCH_TMS_TRANSLATIONS';
export const FETCH_TMS_CONFIG = 'FETCH_TMS_CONFIG';
export const FETCH_TMS_ERRORS = 'FETCH_TMS_ERRORS';
export const FETCH_TMS_TRANSLATIONS_COMPLETE = 'FETCH_TMS_TRANSLATIONS_COMPLETE';
export const FETCH_TMS_CONFIG_COMPLETE = 'FETCH_TMS_CONFIG_COMPLETE';
export const FETCH_TMS_ERRORS_COMPLETE = 'FETCH_TMS_ERRORS_COMPLETE';

export interface TMSLabel {
  translationSpace: string;
  translation: string;
  language: string;
  fetched?: boolean;
  data?: any;
  error?: any;
}
export interface TMSData {
  labels?: TMSLabel[];
  labelsConfig?: TMSLabel[];
}
